/*
* Config
*/

var ROOT = 'https://www.tnccmaps.org/arcgis/rest/services/Salmon/';
var STATUS_ENDPOINT = ROOT + 'CA_Salmon_Status_2016/MapServer/';
var RIVERS_ENDPOINT = ROOT + 'CA_Salmon_Rivers_Spawning_Range/MapServer/';

var popupTemplate = {
  withStatus: {
    title: '{ESU_DPS}',
    content: '<ul><li>Status: {Status}</li></ul>',
  },
  noStatus: {
    title: '{ESU_DPS}',
    content: '<ul><li>{Class}</li></ul>',
  },
  watershed: {
    title: '{W_Name_1}',
  },
};

var statusConfig = {
  'all-species': {
    layers: [
      {
        title: 'Spawning Range',
        url: RIVERS_ENDPOINT + '2',
        legendEnabled: true,
        type: 'group-layer',
        subLayers: [
          {
            title: 'Historical',
            url: RIVERS_ENDPOINT + '4',
            legendEnabled: true,
          },
          {
            title: 'Current',
            url: RIVERS_ENDPOINT + '3',
            legendEnabled: true,
          },
        ]
      },
      {
        title: 'Watersheds',
        url: RIVERS_ENDPOINT + '1',
        legendEnabled: true,
        popupTemplate: popupTemplate.watershed,
      },
    ]
  },
  'coho': {
    layers: [
      {
        title: 'Coho',
        url: STATUS_ENDPOINT + '6',
        legendEnabled: true,
        popupTemplate: popupTemplate.noStatus,
      },
      {
        title: 'Status',
        url: STATUS_ENDPOINT + '5',
        legendEnabled: true,
        popupTemplate: popupTemplate.withStatus,
      },
      {
        title: 'Snapshot Watersheds',
        url: STATUS_ENDPOINT + '0',
        legendEnabled: true,
        popupTemplate: popupTemplate.watershed,
      },
    ]
  },
  'fall-and-late-fall-run-chinook': {
    layers: [
      {
        title: 'Fall and Late Fall-run Chinook',
        url: STATUS_ENDPOINT + '8',
        legendEnabled: true,
        popupTemplate: popupTemplate.noStatus,
      },
      {
        title: 'Status',
        url: STATUS_ENDPOINT + '7',
        legendEnabled: true,
        popupTemplate: popupTemplate.withStatus,
      },
      {
        title: 'Snapshot Watersheds',
        url: STATUS_ENDPOINT + '1',
        legendEnabled: true,
        popupTemplate: popupTemplate.watershed,
      },
    ]
  },
  'winter-run-chinook': {
    layers: [
      {
        title: 'Winter-run Chinook',
        url: STATUS_ENDPOINT + '10',
        legendEnabled: true,
        popupTemplate: popupTemplate.noStatus,
      },
      {
        title: 'Status',
        url: STATUS_ENDPOINT + '9',
        legendEnabled: true,
        popupTemplate: popupTemplate.withStatus,
      },
      {
        title: 'Snapshot Watersheds',
        url: STATUS_ENDPOINT + '2',
        legendEnabled: true,
        popupTemplate: popupTemplate.watershed,
      },
    ]
  },
  'spring-run-chinook': {
    layers: [
      {
        title: 'Spring-run Chinook',
        url: STATUS_ENDPOINT + '12',
        legendEnabled: true,
        popupTemplate: popupTemplate.noStatus,
      },
      {
        title: 'Status',
        url: STATUS_ENDPOINT + '11',
        legendEnabled: true,
        popupTemplate: popupTemplate.withStatus,
      },
      {
        title: 'Snapshot Watersheds',
        url: STATUS_ENDPOINT + '3',
        legendEnabled: true,
        popupTemplate: popupTemplate.watershed,
      },
    ]
  },
  'steelhead': {
    layers: [
      {
        title: 'Coho',
        url: STATUS_ENDPOINT + '14',
        legendEnabled: true,
        popupTemplate: popupTemplate.noStatus,
      },
      {
        title: 'Status',
        url: STATUS_ENDPOINT + '13',
        legendEnabled: true,
        popupTemplate: popupTemplate.withStatus,
      },
      {
        title: 'Snapshot Watersheds',
        url: STATUS_ENDPOINT + '4',
        legendEnabled: true,
        popupTemplate: popupTemplate.watershed,
      },
    ]
  },
};

var riversConfig = {
  layers: [
    {
      title: 'Spawning Range',
      url: RIVERS_ENDPOINT + '2',
      legendEnabled: true,
      type: 'group-layer',
      subLayers: [
        {
          title: 'Historical',
          url: RIVERS_ENDPOINT + '4',
          legendEnabled: true,
        },
        {
          title: 'Current',
          url: RIVERS_ENDPOINT + '3',
          legendEnabled: true,
        },
      ]
    },
    {
      title: 'Watersheds',
      url: RIVERS_ENDPOINT + '1',
      legendEnabled: true,
      noMinScale: true,
    },
  ],
};

var slugToWatershed = {
  'albion-river': 'Albion River',
  'american-river': 'American River',
  'antelope-creek': 'Antelope Creek',
  'aptos-creek': 'Aptos Creek',
  'battle-creek': 'Battle Creek',
  'big-chico-creek': 'Big Chico Creek',
  'big-river': 'Big River',
  'butte-creek': 'Butte Creek',
  'carmel-river': 'Carmel River',
  'caspar-creek': 'Caspar Creek',
  'clear-creek': 'Clear Creek',
  'cosumnes-river': 'Cosumnes River',
  'cottonwood-creek': 'Cottonwood Creek',
  'cow-creek': 'Cow Creek',
  'deer-creek': 'Deer  Creek',
  'eel-river-south-fork': 'South Fork Eel River',
  'feather-river': 'Feather River',
  'garcia-river': 'Garcia River',
  'gazos-creek': 'Gazos Creek',
  'humboldt-bay-tributaries': 'Humboldt Bay Tributaries',
  'klamath-river-lower': 'Lower Klamath River',
  'klamath-river-middle-and-upper': 'Middle and Upper Klamath River',
  'lagunitas-creek': 'Lagunitas Creek',
  'little-river': 'Little River',
  'malibu-creek': 'Malibu Creek',
  'mattole-river': 'Mattole River',
  'merced-river': 'Merced River',
  'mill-creek': 'Mill Creek',
  'mokelumne-river': 'Mokelumne River',
  'navarro-river': 'Navarro River',
  'noyo-river': 'Noyo River',
  'pescadero-creek': 'Pescadero Creek',
  'pine-gulch-creek': 'Pine Gulch Creek',
  'pudding-creek': 'Pudding Creek',
  'redwood-creek-humboldt-county': 'Redwood Creek (Humboldt Co)',
  'redwood-creek-marin-county': 'Redwood Creek (Marin Co)',
  'russian-river': 'Russian River',
  'sacramento-river-mainstem': 'Sacramento River (mainstem)',
  'salmon-river': 'Salmon River',
  'san-lorenzo-river': 'San Lorenzo River',
  'san-vicente-creek': 'San Vicente Creek',
  'santa-clara-river': 'Santa Clara River',
  'scott-creek': 'Scott Creek',
  'scott-river': 'Scott River',
  'shasta-river': 'Shasta River',
  'smith-river': 'Smith River',
  'stanislaus-river': 'Stanislaus River',
  'ten-mile-river': 'Ten Mile River',
  'topanga-canyon-creek': 'Topanga Canyon Creek',
  'trinity-river': 'Trinity River',
  'tuolumne-river': 'Tuolumne River',
  'usal-creek': 'Usal Creek',
  'ventura-river': 'Ventura River',
  'waddell-creek': 'Waddell Creek',
  'yuba-river': 'Yuba River',
};


/*
* Utility functions
*/

function createFeatureLayer(layerConfig, FeatureLayer) {
  var featureLayer = new FeatureLayer({
    title: layerConfig.title,
    url: layerConfig.url,
    legendEnabled: layerConfig.legendEnabled,
    popupTemplate: layerConfig.popupTemplate
  });
  if (layerConfig.noMinScale) {
    featureLayer.minScale = 0;
    featureLayer.maxScale = 0;
  };
  return featureLayer;
};

function loadLayers(layersConfig, map, FeatureLayer, GroupLayer) {
  layersConfig.forEach(function(layer) {
    if (layer.type === 'group-layer') {
      var subLayers = layer.subLayers.map(function(subLayer) {
        var featureLayer = createFeatureLayer(subLayer, FeatureLayer);
        return featureLayer;
      });
      var groupLayer = new GroupLayer({
        title: layer.title,
        layers: subLayers
      });
      map.add(groupLayer);
    } else {
      var featureLayer = createFeatureLayer(layer, FeatureLayer);
      map.add(featureLayer);
    }
  });
};

function initLegend(view, Legend, Expand) {
  var legend = new Legend({
    view: view,
    layerInfos: view.layerViews.items
  });
  var legendExpand = new Expand({
    view: view,
    content: legend,
    group: 'bottom-right',
    expanded: true,
    expandIconClass: 'esri-icon-layer-list',
    expandTooltip: 'Legend',
  });
  view.ui.add(legendExpand, 'top-right');
};

function initHomeButton(view, Home) {
  var homeBtn = new Home({ view: view, });
  view.ui.add(homeBtn, 'top-left');
};

function initScaleBar(view, ScaleBar) {
  var scaleBar = new ScaleBar({ view: view, style: 'ruler', });
  view.ui.add(scaleBar, 'bottom-left');
};


/*
* Init Statewide Status Map
*
* NOTE: assumes that this will be executed on initial page load and
* each time users select a new species tab. Expects species slug
* (e.g. 'all-species') as argument
*/

function initStatusMap(species) {
  require([
    'esri/Map',
    'esri/views/MapView',
    'esri/layers/FeatureLayer',
    'esri/layers/GroupLayer',
    'esri/widgets/Expand',
    'esri/widgets/Legend',
    'esri/widgets/Home',
    'esri/widgets/ScaleBar',
  ], function(Map, MapView, FeatureLayer, GroupLayer, Expand, Legend, Home, ScaleBar) {

    var config = statusConfig; 
    var map = new Map({ basemap: 'topo-vector' });
    var view = new MapView({
      container: 'statewide-status-map',  // id of the map's container div
      map: map,
      center: [-120, 37.25],
      zoom: 6,
    });

    view.when(function() {
      var layers = config[species].layers;
      loadLayers(layers, map, FeatureLayer, GroupLayer);
      initLegend(view, Legend, Expand);
      initHomeButton(view, Home);
      initScaleBar(view, ScaleBar);
      view.popup.collapseEnabled = false;
    });

  });
};

/*
* Init Salmon Rivers Map
*
* NOTE: assumes that this will be executed only once after the
* #rivers-map div is ready
*/

function initRiversMap(river) {
  require([
    'esri/Map',
    'esri/views/MapView',
    'esri/layers/FeatureLayer',
    'esri/layers/GroupLayer',
    'esri/widgets/Expand',
    'esri/widgets/Legend',
    'esri/widgets/Home',
    'esri/widgets/ScaleBar',
  ], function(Map, MapView, FeatureLayer, GroupLayer, Expand, Legend, Home, ScaleBar) {

    var highlight;
    function zoomToFeature(feature, layerView) {
      if (highlight) {
        highlight.remove();
      }
      highlight = layerView.highlight(feature);
      var extent = feature.geometry.extent.clone();
      view.goTo(extent, { animate: true, duration: 500, });
    };

    function goToWatershed(watershed) {
      var wsName = slugToWatershed[watershed];
      var wsLayer = map.layers.items.filter(function(layer) {
        return layer.title === 'Watersheds';
      })[0];
      view.whenLayerView(wsLayer).then(function(layerView) {
        var query = wsLayer.createQuery();
        query.where = "W_Name_1 = '" + wsName + "'";
        layerView.queryFeatures(query).then(function(response) {
          if (response.features.length > 0) {
            zoomToFeature(response.features[0], layerView);
          }
          else {
            wsLayer.queryFeatures(query).then(function(response) {
              zoomToFeature(response.features[0], layerView);
            });
          }
        });
      });
    };

    function initWatershedListener(river) {
      // goToWatershed(river);

      document.addEventListener('watershedSelected', function(e) {
        // listens for a custom event with the watershed's slug
        // passed in as value for event.detail.watershed
        goToWatershed(e.detail.watershed);
      });
    };

    var config = riversConfig;
    var map = new Map({ basemap: 'topo-vector' });
    var view = new MapView({
      container: 'rivers-map',  // id of the map's container div
      map: map,
      center: [-120, 37.25],
      zoom: 6,
    });

    view.when(function() {
      loadLayers(config.layers, map, FeatureLayer, GroupLayer);
      initLegend(view, Legend, Expand);
      initHomeButton(view, Home);
      initScaleBar(view, ScaleBar);
      initWatershedListener(river);
    });
    // view.on("mouse-wheel", function(event) {
    //   // prevents zooming with the mouse-wheel event
    //   event.stopPropagation();
    // });
  });

};